module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tabs', {
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "cyan",
    slot: "activators"
  }, [_c('v-tabs-item', {
    attrs: {
      "href": "#showcase",
      "ripple": ""
    }
  }, [_vm._v("\n      Show\n      ")]), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#onlycode",
      "ripple": ""
    }
  }, [_vm._v("\n      Code\n      ")]), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#onlyapi",
      "ripple": ""
    }
  }, [_vm._v("\n      Api\n      ")]), _vm._v(" "), _c('v-tabs-slider', {
    class: _vm.$store.state.themeBackgroundColor
  })], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "showcase"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("showcase")], 2)], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "onlycode"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("onlycode")], 2)], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "onlyapi"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_vm._t("onlyapi")], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cb9ff60","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/onlyone/components/showcode.vue
// module id = 755
// module chunks = 1